import {
    RESET_SESSION,
    GET_SESSION_LIST,
    GET_SESSION_LIST_SUCCESS,
    GET_SESSION_LIST_ERROR,
    GET_SESSION_DATA,
    GET_SESSION_DATA_SUCCESS,
    GET_SESSION_DATA_ERROR
} from '../constants/ActionTypes';

export const resetSession = () => {
    return {
        type: RESET_SESSION,
    };
};

export const getSessionList = (payload) => {
    return {
        type: GET_SESSION_LIST,
        payload: payload
    };
};

export const getSessionListSuccess = (sessionListResponse) => {
    return {
        type: GET_SESSION_LIST_SUCCESS,
        payload: sessionListResponse
    };
};

export const getSessionListError = (sessionListResponse) => {
    return {
        type: GET_SESSION_LIST_ERROR,
        payload: sessionListResponse
    };
};

export const getSessionData = (payload) => {
    return {
        type: GET_SESSION_DATA,
        payload: payload
    };
};

export const getSessionDataSuccess = (sessionDataResponse) => {
    return {
        type: GET_SESSION_DATA_SUCCESS,
        payload: sessionDataResponse
    };
};

export const getSessionDataError = (sessionDataResponse) => {
    return {
        type: GET_SESSION_DATA_ERROR,
        payload: sessionDataResponse
    };
};
